import { FinalCta } from '../components/landing/FinalCta';
import pt from '../locales/pt';

const pagePad =
  'px-space-5 py-space-12 mid:px-space-10 mid:py-space-16 wide:px-space-20 wide:py-space-24';

/**
 * About · 375/768/1280 × light/dark — evplanner-gleb-design-system.pen
 */
export function About() {
  return (
    <div className="flex flex-col">
      <section className={`flex flex-col items-center ${pagePad}`}>
        <div className="flex w-full max-w-3xl flex-col gap-space-10">
          <div className="flex flex-col gap-space-3">
            <span className="type-section text-sage-700 dark:text-sage-300">{pt.about.eyebrow}</span>
            <h1 className="type-landing-h2">{pt.about.title}</h1>
          </div>
          <div className="rounded-ds-lg border border-sage-border bg-sage-tint p-space-8">
            <p className="type-landing-lead font-display font-semibold text-foreground">
              {pt.about.mission}
            </p>
          </div>
          <div className="flex flex-col gap-space-4">
            {pt.about.body.map((paragraph) => (
              <p key={paragraph} className="type-body leading-relaxed text-muted-foreground">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>
      <FinalCta />
    </div>
  );
}
